<template>
  <div v-if="assets.length" class="striped">
    <section class="other-assets container font-semibold text-xl lg_text-2xl" data-testid="other-assets-section">
      <p class="mb-6" data-testid="other-assets-section-title">{{ hasVrifiedAssets ? 'Other Assets' : 'Assets' }}</p>
      <Carousel v-if="assets && carouselPages" class="block sm_hidden" data-testid="asset-carousel">
        <CarouselSlide v-for="(_page, pageIndex) in carouselPages" :key="pageIndex" class="flex flex-col w-full">
          <div
            v-for="asset in getAssetsByIndex(pageIndex)"
            :key="asset.id"
            class="carousel-cell w-full h-auto p-4 border border-gray-400 rounded-md my-2 sm_h-20"
          >
            <p class="asset-name flex text-base font-medium text-black mb-1">{{ asset.name }}</p>
            <div v-if="asset.region" class="asset-details text-sm font-normal text-gray-700">{{ asset.region.name }}</div>
            <div class="asset-details text-sm font-normal text-gray-700">{{ assetDetails(asset) }}</div>
          </div>
        </CarouselSlide>
      </Carousel>
      <div class="desktop-style hidden max-w-full sm_flex flex-wrap gap-8">
        <div
          v-for="asset in assets"
          :key="asset.id"
          class="border border-gray-400 rounded-md h-26 p-4 flex-shrink-0 bg-white max-w-full"
          data-testid="asset"
        >
          <p class="asset-name flex text-base font-medium text-black mb-1" data-testid="other-asset-name">{{ asset.name }}</p>
          <div v-if="asset.region" class="asset-details text-sm font-normal text-gray-700" data-testid="other-asset-region">
            {{ asset.region.name }}
          </div>
          <div class="asset-details text-sm font-normal text-gray-700" data-testid="other-asset-details">{{ assetDetails(asset) }}</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { getPercentOwnership } from '@/lib/companyPageHelpers'
import type { Asset } from '@/entities/asset'

const props = defineProps({
  assets: {
    type: Array as PropType<DeepReadonly<Asset[]>>,
    default: () => [],
  },
  hasVrifiedAssets: {
    type: Boolean,
    required: true,
  },
})

const carouselPages = computed(() => Math.ceil(props.assets.length / 3))

const getAssetsByIndex = (pageIndex: number) => {
  const indexOfLastPageOfAssets = pageIndex * 3
  const cutoffOfNextPageOfAssets = pageIndex * 3 + 3

  return props.assets.slice(indexOfLastPageOfAssets, cutoffOfNextPageOfAssets)
}

const assetDetails = (asset: DeepReadonly<Asset>) => {
  return [
    asset.commodities.map(c => c.commodity.name).join(', '),
    asset.stage?.name,
    asset.ownership && `${getPercentOwnership(asset.ownership)}\u00a0Ownership`,
  ]
    .filter(x => x)
    .join(' \u2022\u00a0')
}
</script>
